import { extractGroupBySettings } from '@keen.io/query';
import { chronologicalTransformation } from './chronological-transformation';
import { categoricalTransformation } from './categorical-transformation';
import { categoricalChronologicalTransformation } from './categorical-chronological-transformation';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var keys = chartSettings.keys, data = chartSettings.data, tooltipSettings = chartSettings.tooltipSettings;
    var valueFormatter = tooltipSettings === null || tooltipSettings === void 0 ? void 0 : tooltipSettings.formatValue;
    var interval = query.interval, groupBy = query.group_by;
    var isChronologicalAnalysis = !!interval;
    var isCategoricalAnalysis = groupBy && extractGroupBySettings(groupBy).length > 0;
    if (isChronologicalAnalysis && isCategoricalAnalysis) {
        return categoricalChronologicalTransformation(data, keys, valueFormatter, extractGroupBySettings(groupBy));
    }
    else if (isCategoricalAnalysis) {
        return categoricalTransformation(data, keys, valueFormatter, extractGroupBySettings(groupBy));
    }
    else {
        return chronologicalTransformation(data, keys, valueFormatter);
    }
};
